/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Recovery_MetaInputs */

const en_us2_recovery_meta = /** @type {(inputs: Recovery_MetaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`from the last 7 days of sets`)
};

const pt_br2_recovery_meta = /** @type {(inputs: Recovery_MetaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`pelas séries dos últimos 7 dias`)
};

const es_419_recovery_meta = /** @type {(inputs: Recovery_MetaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`según las series de los últimos 7 días`)
};

const pt_pt2_recovery_meta = /** @type {(inputs: Recovery_MetaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`pelas séries dos últimos 7 dias`)
};

const fr_fr2_recovery_meta = /** @type {(inputs: Recovery_MetaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`d'après les séries des 7 derniers jours`)
};

const de_de2_recovery_meta = /** @type {(inputs: Recovery_MetaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`aus den Sätzen der letzten 7 Tage`)
};

const it_it2_recovery_meta = /** @type {(inputs: Recovery_MetaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`dalle serie degli ultimi 7 giorni`)
};

/**
* | output |
* | --- |
* | "from the last 7 days of sets" |
*
* @param {Recovery_MetaInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const recovery_meta = /** @type {((inputs?: Recovery_MetaInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Recovery_MetaInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_recovery_meta(inputs)
	if (locale === "es-419") return es_419_recovery_meta(inputs)
	if (locale === "pt-PT") return pt_pt2_recovery_meta(inputs)
	if (locale === "fr-FR") return fr_fr2_recovery_meta(inputs)
	if (locale === "de-DE") return de_de2_recovery_meta(inputs)
	if (locale === "it-IT") return it_it2_recovery_meta(inputs)
	return en_us2_recovery_meta(inputs)
});
export { recovery_meta as "recovery.meta" }